import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { selectLocationInfo } from '../../redux-state/selectors';
import { useEffect } from 'react';
import { DECODE_ZIP } from '../../redux-state/fees/types';
import { UPDATE_LOCATION_INFO } from '../../redux-state/forms/types';
import { GET_LIEN_HOLDER_INFO } from '../../redux-state/types';

function DocForm({ errors }) {
  const locationInfo = useSelector(selectLocationInfo);
  const dispatch = useDispatch();

  const cities = locationInfo.cities || [];
  const states = locationInfo.states || [];
  const countries = locationInfo.countries || [];

  useEffect(() => {
    if (locationInfo.zipCode && locationInfo.zipCode.length === 5) {
      dispatch({
        type: DECODE_ZIP,
        payload: { zipValue: locationInfo.zipCode },
      });
    }
  }, [locationInfo.zipCode, dispatch]);

  useEffect(() => {
    dispatch({
      type: GET_LIEN_HOLDER_INFO,
    })
  }, [locationInfo.state, dispatch])

  useEffect(() => {
    const statesList = locationInfo.states || [];
    const citiesList = locationInfo.cities || [];
    const countriesList = locationInfo.countries || [];

    if (!locationInfo.state || !statesList.includes(locationInfo.state)) {
      const newState = statesList.length === 1 ? statesList[0] : "";
      dispatch({
        type: UPDATE_LOCATION_INFO,
        payload: { key: 'state', value: newState },
      });
    }

    if (!locationInfo.city || !citiesList.includes(locationInfo.city)) {
      const newCity = citiesList.length === 1 ? citiesList[0] : "";
      dispatch({
        type: UPDATE_LOCATION_INFO,
        payload: { key: 'city', value: newCity },
      });
    }

    if (!locationInfo.country || !countriesList.includes(locationInfo.country)) {
      const newCountry = countriesList.length === 1 ? countriesList[0] : "";
      dispatch({
        type: UPDATE_LOCATION_INFO,
        payload: { key: 'country', value: newCountry },
      });
    }
  }, [
    locationInfo.states,
    locationInfo.cities,
    locationInfo.countries,
    locationInfo.state,
    locationInfo.city,
    locationInfo.country,
    dispatch,
  ]);

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_LOCATION_INFO,
      payload: { key, value },
    });
  };

  return (
    <div className="flex flex-col w-full gap-4">
      <div className="p-4 rounded-xl bg-white text-gray-700">
        <p className="text-lg font-bold">Location Details</p>
        <div className="flex flex-wrap justify-between mt-2 text-sm">
          <div className="text-gray-600">Add Location details</div>
          
        </div>

        <div className="flex flex-col md:flex-row mt-4 gap-4 w-full">
          <TextField
            required
            type="text"
            label="Zip Code"
            variant="outlined"
            fullWidth
            value={locationInfo?.zipCode}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 5);
              handleChange('zipCode', value)
            }}
            inputProps={{ maxLength: 5 }}
            error={!!errors.zipCode}
            helperText={errors.zipCode}
          />
          <FormControl fullWidth required error={!!errors.state}>
            <InputLabel>State</InputLabel>
            <Select
              label="State"
              value={locationInfo?.state}
              onChange={(e) => handleChange('state', e.target.value)}
            >
              {states.map((state, index) => (
                <MenuItem key={index} value={state}>{state}</MenuItem>
              ))}
            </Select>
            {errors.state && <div style={{ color: 'red', fontSize: '0.75rem' }}>{errors.state}</div>}
          </FormControl>
        </div>

        <div className="flex flex-col md:flex-row mt-4 gap-4 pb-4 w-full">
          <FormControl fullWidth required error={!!errors.city}>
            <InputLabel>City</InputLabel>
            <Select
              label="City"
              value={locationInfo?.city}
              onChange={(e) => handleChange('city', e.target.value)}
            >
              {cities.map((city, index) => (
                <MenuItem key={index} value={city}>{city}</MenuItem>
              ))}
            </Select>
            {errors.city && <div style={{ color: 'red', fontSize: '0.75rem' }}>{errors.city}</div>}
          </FormControl>

          <FormControl fullWidth required error={!!errors.country}>
            <InputLabel>County</InputLabel>
            <Select
              label="County"
              value={locationInfo?.country}
              onChange={(e) => handleChange('country', e.target.value)}
            >
              {countries.map((country, index) => (
                <MenuItem key={index} value={country}>{country}</MenuItem>
              ))}
            </Select>
            {errors.country && <div style={{ color: 'red', fontSize: '0.75rem' }}>{errors.country}</div>}
          </FormControl>
        </div>
      </div>
    </div>
  );
}

export default DocForm;
